export const formatDateTimeForInput = (dateValue: Date | string | undefined): string => {
    if (!dateValue) return '';

    // Create a date object
    let date: Date;
    if (typeof dateValue === 'string') {
        // Parse ISO 8601 string (e.g., "2026-03-08T14:30:00Z")
        date = new Date(dateValue);
    } else {
        date = new Date(dateValue);
    }

    // Check if date is valid
    if (isNaN(date.getTime())) {
        return '';
    }

    // Format as YYYY-MM-DDTHH:mm for HTML datetime-local input
    // This uses local timezone (what the user sees)
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
};
